import { Auth } from "./auth";
import { Location } from "./location";
import { Sublocation } from "./sublocation";
import { Dashboard } from "./dashboard";
import { Alert } from "./alert";
import { Alert_v2 } from "./alert_v2.js";
import { MachineProfile } from "./machine_profile";
import { CompanyProfile } from "./company_profile";
import { UserRole } from "./user_role";
import { User } from "./user";
import { DataProcess } from "./data_process.js";
import { Sensor } from "./sensor";
import { Notification } from "./notification.js";
import { WorkOrder } from "./work_order";
import { Document } from "./document";
import { Analytics } from "./analytics";
import { AiChatPDF } from "./ai_chat_pdf";

import { Asset } from "./asset.js";
import { Vendor } from "./cmms_vendor";
import { Customer } from "./cmms_customer";
import { Team } from "./cmms_team";
import { Part } from "./cmms_part";
import { Inventory } from "./cmms_inventory";
import { WorkOrderCategory } from "./work_order_category.js";
import { AssetCategory } from "./asset_category.js";
import { PartCategory } from "./part_category.js";
import { Checklist } from "./checklist.js";
import { Task } from "./cmms_task.js";
import { VendorType } from "./vendor_type.js";
import { CustomerType } from "./customer_type.js";
import { Role } from "./role.js";
import { Permission } from "./permission.js";
import { PurchaseOrder } from "./purchase_order.js";
import { WorkOrderRequestComment } from "./work_order_request_comment.js";
import { Matar } from "./matar";
import { AssetCustomField } from "./asset_custom_field.js";
import { NotificationGroup } from "./notification_group.js";
import { Quotation } from "./quotation.js";
import { ChatAssistant } from "./chatAssistant.js";
import { WorkOrderTimeTrackingType } from "./work_order_time_tracking_type.js";
import { WorkOrderAdditionalCostCategory } from "./work_order_additional_cost_category.js";
import { Service } from "./service.js";
import { ServiceCategory } from "./service_category.js";
import { Meter} from "./meter.js";
import { MeterReading } from "./meter_reading.js";
import { MeterMeasurementUnit } from "./meter_measurement_unit.js";
import { Faq } from "./faq.js";
import {PublicLink} from "./cmms_public_url"
import { IssueTracking } from "./issue_tracking.js";
import { IssueTrackingType } from "./issue_tracking_type.js";
import { ProblemType } from "./problem-type.js";
import { Province } from "./province.js";
export const auth = new Auth();
export const aiChatPDF = new AiChatPDF();
export const matar = new Matar();

export const analytics = new Analytics();
export const document = new Document();
export const location = new Location();
export const sublocation = new Sublocation();
export const dataProcess = new DataProcess();
export const alert = new Alert();
export const alertV2 = new Alert_v2();
export const dashboard = new Dashboard();
export const machineProfile = new MachineProfile();
export const companyProfile = new CompanyProfile();
export const company = new CompanyProfile();
export const userRole = new UserRole();
export const user = new User();
export const sensor = new Sensor();
export const notification = new Notification();
export const publicLink = new PublicLink();

export const workOrder = new WorkOrder();
export const workOrderCategory = new WorkOrderCategory();
export const assetCategory = new AssetCategory();
export const partCategory = new PartCategory();
export const checklist = new Checklist();
export const task = new Task();
export const vendorType = new VendorType();
export const customerType = new CustomerType();
export const purchaseOrder = new PurchaseOrder();
export const inventory = new Inventory();
export const team = new Team();
export const part = new Part();
export const asset = new Asset();
export const assetCustomField = new AssetCustomField();
export const customer = new Customer();
export const vendor = new Vendor();

export const role = new Role();
export const permission = new Permission();

export const workOrderRequestComment = new WorkOrderRequestComment();
export const notificationGroup = new NotificationGroup();
export const quotation = new Quotation();
export const chatAssistant = new ChatAssistant();
export const workOrderTimeTrackingType = new WorkOrderTimeTrackingType();
export const workOrderAdditionalCostCategory = new WorkOrderAdditionalCostCategory();
export const service = new Service();
export const serviceCategory = new ServiceCategory();
export const meter = new Meter();
export const meterReading = new MeterReading();
export const meterMeasurementUnit = new MeterMeasurementUnit();
export const faq = new Faq();
export const issueTracking = new IssueTracking();
export const issueTrackingType = new IssueTrackingType();
export const problemType = new ProblemType();
export const province = new Province();